import api from './client';
import {RunScenarioRequest, RunScenarioResponse, Scenario} from '@/types/assistants';

export const scenarioApi = {
    create: (data: any) =>
        api.post('/scenarios', data),

    createFromYaml: (body: any) =>
        api.post('/scenarios_import', body),

    updateFromYaml: (body: any) =>
        api.put('/scenarios_import', body),

    exportScenario: (id: string|number) =>
        api.get('/scenario_export/' + id),

    getOne: (id: number) =>
        api.get<Scenario>(`/scenario/${id}`),

    getAll: () =>
        api.get('/scenarios', { data: {} }),

    update: (data: any) =>
        api.put('/scenarios', data),

    delete: (id: number) =>
        api.delete('/scenarios', { data: { id } }),
    runScenario: (data: RunScenarioRequest) =>
        api.post<RunScenarioResponse>('/run_scenario', data)
};
